import { REGEXPS } from '@/common/const/regexp.const'

export default value => {
  if (!value) {
    return true
  }
  return REGEXPS.emailValidator.test(value)
}
